(function () {
    'use strict';

    angular
        .module('app.home')
        .component('sc3AddActivityModal', {
            templateUrl: 'app/home/activities/add-activity-modal.component.html',
            controller: AddActivityModalComponent,
            bindings: {
                close: '&',
                dismiss: '&',
                resolve: '<'
            }
        });

    var $ = angular.element,
        extend = angular.extend;

    AddActivityModalComponent.$inject = ['$element', 'golfActivityType'];
    function AddActivityModalComponent($element, golfActivityType) {
        // Variables
        var ctrl = this,
            timespan,
            conversion = { days: 86400000, hours: 3600000, minutes: 60000, seconds: 1000, milliseconds: 1 };

        // Properties
        ctrl.datePickerOptions = { minDate: new Date(2017, 0, 1), maxDate: getMaxDate() };

        Object.defineProperty(ctrl, 'activity', { get: getActivity });
        Object.defineProperty(ctrl, 'hours', { get: getHours, set: setHours });
        Object.defineProperty(ctrl, 'minutes', { get: getMinutes, set: setMinutes });
        ctrl.activityTypes = Object.keys(golfActivityType.$metadata).filter(isNotHandicapRound);

        // Methods
        ctrl.$onInit = init;
        ctrl.submit = submit;
        ctrl.focusout = focusout;

        //////////////////

        function init() {
            timespan = format(ctrl.activity.duration);
        }

        function submit() {
            if (ctrl.form.$valid)
                ctrl.close({ $value: ctrl.activity });
        }

        function getActivity() {
            return ctrl.resolve.activity;
        }
        function getHours() {
            return timespan.hours;
        }
        function setHours(value) {
            ctrl.activity.duration = parse(extend(timespan, { hours: value }));
        }
        function getMinutes() {
            return timespan.minutes;
        }
        function setMinutes(value) {
            ctrl.activity.duration = parse(extend(timespan, { minutes: value }));
        }

        function focusout(e) {
            if (!e.currentTarget.contains(e.relatedTarget))
                ctrl.form.duration.$setTouched();
        }

        function getMaxDate() {
            var now = new Date();
            return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999); // end of day
        }

        function isNotHandicapRound(type) {
            return type !== golfActivityType.HandicapRound;
        }

        function parse(value) {
            return Object.entries(value).reduce(reduce, null);
            function reduce(acc, cur, index) {
                return cur[1] != null ? acc + cur[1] * conversion[cur[0]] : acc;
            }
        }

        function format(value) {
            return Object.entries(conversion).reduce(reduce, {});
            function reduce(acc, cur, index) {
                var quotient = acc[cur[0]] = Math.trunc(value / cur[1]) || null;
                value -= quotient * cur[1];
                return acc;
            }
        }
    }
})();